export const filterCustomFieldsConfig = (customFieldsUI, formSection, resourceType) => {
  // Filter based on form section
  let config = customFieldsUI.filter(
    (section) =>
      section.formSection === formSection &&
      (section.resourceTypes === undefined ||
        section.resourceTypes.includes(resourceType))
  );
  // Filter fields based on resource type
  // Make a copy to avoid side effects on other custom field sections
  config = structuredClone(config);
  config = config.map((section) => {
    section.fields = section.fields
      .filter(
        (f) => f.resource_types === undefined || f.resource_types.includes(resourceType)
      )
      .map((f) => {
        f.props = { ...f.props, resourceType }; // Inject resourceType on every custom field
        return f;
      });
    return section;
  });

  return config;
};
